import React, { useEffect, useState } from 'react';
import update from 'immutability-helper';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdOutlineCloudDownload, MdOutlineContentCopy, MdVerticalAlignBottom, MdVerticalAlignTop } from 'react-icons/md';
import { toast } from 'react-toastify';

import { StorageEnum } from '../../../utils/enumerators/Storage.enum';
import { getS1Distributions, getS1Status } from '../../../utils/services/service';
import { formatDateToBrazilian, getTimeOfflineText } from '../../../utils/utils';
import PageDefault from '../../PageDefault/PageDefault';

import './StatusS1.scss';

let interval;
function StatusS1() {
	const refreshMinutesStorage = localStorage.getItem(StorageEnum.REFRESH_MINUTES);
	const headerExpanded = JSON.parse(localStorage.getItem(StorageEnum.HEADER_EXPANDED));
	const [expanded, setExpanded] = useState(headerExpanded || false);

	const [cloudfronts, setCloudfronts] = useState([]);
	const [pesquisa, setPesquisa] = useState('');
	const [awsState, setAwsState] = useState(true);
	const [refreshMinutes, setRefreshMinutes] = useState(refreshMinutesStorage || 15);
	const [countdown, setCountdown] = useState(``);

	let countdownDuration = 0;

	useEffect(async () => {
		getClientsServerStatus();
	}, []);

	useEffect(() => {
		if (cloudfronts.length > 0) {
			startCountdown();
		}

		localStorage.setItem(StorageEnum.REFRESH_MINUTES, refreshMinutes);
	}, [refreshMinutes]);

	useEffect(() => {
		localStorage.setItem(StorageEnum.HEADER_EXPANDED, expanded.toString());
	}, [expanded]);

	function startCountdown() {
		if (interval != null) {
			clearInterval(interval);
			countdownDuration = 0;
		}

		interval = setInterval(function () {
			if (document.location.pathname != '/s1-mobile/status') {
				clearInterval(interval);
				return;
			}
			countdownDuration += 1000;

			var total = refreshMinutes * 60 * 1000;

			var minutes = Math.floor((total - countdownDuration) / 60000);
			var seconds = (((total - countdownDuration) % 60000) / 1000).toFixed(0);

			if (countdownDuration >= total) {
				setCountdown(`Atualizando...`);
				clearInterval(interval);
				location.reload();
			} else {
				setCountdown(`Atualizará em ${minutes} minuto(s) e ${seconds} segundo(s)...`);
			}
		}, 1000);
	}

	function getClientsServerStatus() {
		getS1Distributions(
			(distributions) => {
				setCloudfronts(distributions);

				startCountdown();

				distributions.forEach((distribution) => {
					getS1Status(distribution.domain, (status) => {
						if (status == null) {
							distribution.serverStatus = 'offline';
							distribution.resetStatus = 'disabled';
							distribution.resetError = 'Servidor offline';
						} else {
							const resetError = status.mensagem?.includes('reset');

							distribution.serverStatus = status.servidorAtivo || resetError ? 'online' : 'offline';
							distribution.resetStatus = distribution.serverStatus == 'online' && !resetError ? 'enabled' : 'disabled';

							if (status.mensagem) {
								distribution.resetError = status.mensagem;
							}
						}

						let timeOffline = null;

						let s1MobileOfflines = JSON.parse(localStorage.getItem(StorageEnum.S1_MOBILE_OFFLINES));

						if (s1MobileOfflines == null) {
							s1MobileOfflines = [];
						}

						const clientOfflineIndex = s1MobileOfflines.findIndex((x) => x.domain == distribution.domain);

						if (clientOfflineIndex >= 0) {
							if (distribution.serverStatus == 'online') {
								s1MobileOfflines.splice(clientOfflineIndex, 1);
							} else {
								timeOffline = s1MobileOfflines[clientOfflineIndex].time;
							}
						} else if (distribution.serverStatus != 'online' && clientOfflineIndex < 0) {
							timeOffline = new Date().getTime();
							s1MobileOfflines.push({ domain: distribution.domain, time: timeOffline });
						}

						localStorage.setItem(StorageEnum.S1_MOBILE_OFFLINES, JSON.stringify(s1MobileOfflines));

						distribution.timeOffline = timeOffline;

						if (timeOffline) {
							distribution.offlineText = getTimeOfflineText(timeOffline);
						}

						const index = distributions.findIndex((emp) => emp.domain === distribution.domain);

						let updatedList = update(distributions, {
							$splice: [[index, 1, distribution]],
						});

						updatedList.sort((a, b) => (a.timeOffline < b.timeOffline ? 1 : -1));

						updatedList = updatedList.sort(function (a, b) {
							if (a.serverStatus == null && b.serverStatus != null) {
								return -1;
							}
							if (a.serverStatus != null && b.serverStatus == null) {
								return 1;
							}

							return 0;
						});

						updatedList = updatedList.sort(function (a, b) {
							if (a.serverStatus == 'offline' && b.serverStatus == 'online') {
								return -1;
							}
							if (a.serverStatus == 'online' && b.serverStatus == 'offline') {
								return 1;
							}

							return 0;
						});

						updatedList = updatedList.sort(function (a, b) {
							if (a.resetStatus == 'disabled' && b.resetStatus == 'enabled') {
								return -1;
							}
							if (a.resetStatus == 'enabled' && b.resetStatus == 'disabled') {
								return 1;
							}
							return 0;
						});

						setCloudfronts(updatedList);
					});
				});
			},
			() => {
				setAwsState(false);
			},
		);
	}

	function sync() {
		localStorage.removeItem(StorageEnum.S1_DISTRIBUTIONS);

		setCountdown(`Atualizando...`);
		clearInterval(interval);
		location.reload();
	}

	return (
		<PageDefault showFooter={!expanded}>
			<div className="status s1-mobile">
				<div className="header">
					<span className="title">Status S1 Mobile</span>
					{!expanded ? (
						<MdVerticalAlignTop
							size={30}
							className="menu-expand"
							title="Comprimir"
							cursor={'pointer'}
							onClick={() => setExpanded(!expanded)}
						/>
					) : (
						<MdVerticalAlignBottom
							size={30}
							className="menu-expand"
							title="Expandir"
							cursor={'pointer'}
							onClick={() => setExpanded(!expanded)}
						/>
					)}
				</div>

				{!awsState && (
					<div className="message centered">
						<span>Houve um erro ao realizar a busca de cloudfronts na AWS.</span>
					</div>
				)}

				{awsState && (
					<>
						{cloudfronts.length == 0 && <span className="message centered">Carregando...</span>}
						{cloudfronts.length > 0 && (
							<>
								<div className="countdown">{countdown}</div>

								{!expanded && (
									<div className="search-header">
										<div className="search">
											<input
												placeholder={`Pesquise pelo nome ou cloudfront...`}
												value={pesquisa}
												className="pesquisa"
												type="search"
												onChange={(e) => setPesquisa(e.target.value)}
											/>

											<MdOutlineCloudDownload
												className="refresh"
												title="Sincronizar novamente com a AWS"
												onClick={sync}
											/>

											<div className="refresh-configuration">
												<span>Atualiza a cada</span>

												<input
													value={refreshMinutes}
													type="number"
													min="1"
													max="15"
													step="1"
													onChange={(e) => setRefreshMinutes(e.target.value)}
												/>

												<span>minuto(s)</span>
											</div>
										</div>
									</div>
								)}

								<div className="status-content">
									<span className="offline-info">A data e tempo offline são armazenados localmente no navegador e podem estar incorretas.</span>
									<table>
										<thead>
											<tr>
												<th>Descrição</th>
												<th>Cloudfront</th>
												<th className="column-centered">Servidor</th>
												<th className="column-centered">Reset</th>
												<th className="column-centered">Data offline</th>
												<th className="column-centered">Ação</th>
											</tr>
										</thead>

										<tbody>
											{cloudfronts
												.filter(
													(cloudfront) =>
														pesquisa == '' ||
														cloudfront.domain.toUpperCase().includes(pesquisa.toUpperCase()) ||
														cloudfront.comment.toUpperCase().includes(pesquisa.toUpperCase()),
												)
												.map((cloudfront, index) => (
													<tr key={`cloudfront-${index}`}>
														<td>{cloudfront.comment.replace('S1 MOBILE - ', '')}</td>

														<td>{cloudfront.domain}</td>

														<td className={`column-centered server-status ${cloudfront.serverStatus}`}>
															{cloudfront.serverStatus == null && <AiOutlineLoading3Quarters className="spin" />}

															<div title={cloudfront.serverStatus}></div>
														</td>

														<td className={`column-centered reset-status ${cloudfront.resetStatus}`}>
															{cloudfront.resetStatus == null && <AiOutlineLoading3Quarters className="spin" />}

															{cloudfront.resetStatus != null && <div title={cloudfront.resetError || cloudfront.resetStatus}></div>}
														</td>

														<td className="column-centered time-offline">
															{formatDateToBrazilian(cloudfront.timeOffline)} - {cloudfront.offlineText}
														</td>

														<td className="column-centered copy">
															<MdOutlineContentCopy
																title="Copiar"
																onClick={() => {
																	navigator.clipboard.writeText(cloudfront.domain);
																	toast.success('Copiado para a área de transferência!');
																}}
															/>
														</td>
													</tr>
												))}
										</tbody>
									</table>
								</div>
							</>
						)}
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default StatusS1;
